/**
 * Per-organization loading animation on serviceapp.ai (stored in organizations.branding).
 * toolsandbubbles.com always uses soap bubbles — not controlled here.
 */

export const SAAS_LOADER_STYLES = ['bubbles', 'pulse', 'minimal'] as const;
export type SaasLoaderStyle = (typeof SAAS_LOADER_STYLES)[number];

export const SAAS_LOADER_STYLE_LABELS: Record<SaasLoaderStyle, string> = {
  bubbles: 'Soap bubbles (Tools & Bubbles style)',
  pulse: 'Pulse rings (ServiceApp default)',
  minimal: 'Minimal (logo only)',
};

export const SAAS_DEFAULT_LOADER_STYLE: SaasLoaderStyle = 'pulse';

export function isSaasLoaderStyle(value: string): value is SaasLoaderStyle {
  return (SAAS_LOADER_STYLES as readonly string[]).includes(value);
}

/** Read loader_style from org branding JSON (super admin → Company Profile on SaaS). */
export function resolveLoaderStyleFromBranding(branding?: Record<string, unknown> | null): SaasLoaderStyle {
  if (!branding || typeof branding !== 'object') {
    return SAAS_DEFAULT_LOADER_STYLE;
  }
  const raw = String(branding.loader_style ?? branding.loaderStyle ?? '')
    .trim()
    .toLowerCase();
  if (isSaasLoaderStyle(raw)) return raw;
  return SAAS_DEFAULT_LOADER_STYLE;
}
